import React from "react";

export const InfoPanel = ({
  icon: Icon,
  iconSrc,
  value,
  total,
  barColor
}: {
  icon?: React.ElementType,
  iconSrc?: string,
  value: string | number,
  total?: number,
  barColor?: string
}) => (
  <div className="flex items-center bg-gray-900/80 p-2 rounded-lg shadow-lg text-white min-w-[120px]">
    {Icon && <Icon className="w-7 h-7 mr-3 text-yellow-400" />}
    {iconSrc && <img src={iconSrc} alt="icon" className="w-7 h-7 mr-3" />}
    <div className="flex-grow">
      <div className="font-bold text-lg">{value}</div>
      {total !== undefined && (
        <div className="w-full bg-gray-600 rounded-full h-2.5 mt-1">
          <div className={`${barColor} h-2.5 rounded-full`} style={{ width: `${(Number(value) / total) * 100}%` }}></div>
        </div>
      )}
    </div>
  </div>
);
